import {
  assignReadTasksReadTasksAssignPatch,
  AssignReadTasksReadTasksAssignPatchResponse,
  AssignReadTasksReadTasksAssignPatchData,
  HTTPValidationError,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useAssignTasksMutation = (): UseMutationResult<
  AssignReadTasksReadTasksAssignPatchResponse,
  AxiosError<HTTPValidationError>,
  AssignReadTasksReadTasksAssignPatchData
> => {
  return useMutation<
    AssignReadTasksReadTasksAssignPatchResponse,
    AxiosError<HTTPValidationError>,
    AssignReadTasksReadTasksAssignPatchData
  >({
    mutationFn: async (body) => {
      const response = await assignReadTasksReadTasksAssignPatch({
        query: body.query,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ReadTasksList'] })
    },
  })
}
